// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"fa4ea9a9","128":"c7ff5405","335":"c7ff5405","363":"b6f6dd56","451":"c7ff5405","462":"c7ff5405","538":"079656bd","893":"b6f6dd56"}[chunkId] + ".chunk.css";
};